import { useEffect, useRef, useState } from "react";

import { TextField, Button } from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import { useQuery } from "@tanstack/react-query";
import { getUserReport, getGenReport } from "../../Services/Api";
import ArrayExcelSaver from '../ArrayExcelSaver'


/**форма поиска товара по части названия или части артикула 1с */
const Report = () => {
  const [date, setDate] = useState('');
  const [barCode, setBarCode] = useState('');

  const { data: genData, isLoading: isGenDataLoading, isError: isGenDataError, refetch: getGenData } = useQuery({
    queryKey: ['getGenReport', date, barCode],
    queryFn: () => getGenReport({ searchDate: date, searchArt: barCode }),
    // Отключаем автоматический запрос при монтировании компонента
    enabled: false,
    // Отключаем автоматический перезапрос по интервалу
    refetchInterval: false,
    // Отключаем фоновые перезапросы при смене фокуса окна или потере сети
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    // Задаем время жизни кеша (1 минута), после которого он считается устаревшим
    staleTime: 1 * 60 * 1000,
  })
  const { data: userData, isLoading: isUserDataLoading, isError: isUserDataError, refetch: getUserData } = useQuery({
    queryKey: ['getUserReport', date, barCode],
    queryFn: () => getUserReport({ searchDate: date, searchArt: barCode }),
    // Отключаем автоматический запрос при монтировании компонента
    enabled: false,
    // Отключаем автоматический перезапрос по интервалу
    refetchInterval: false,
    // Отключаем фоновые перезапросы при смене фокуса окна или потере сети
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    // Задаем время жизни кеша (1 минута), после которого он считается устаревшим
    staleTime: 1 * 60 * 1000,
  })
  console.log('!!!userData,', userData)

  const handleBuildReport = () => {
    getGenData();
    getUserData();
  }
  const genOutArr = (genData?.payload?.data && Array.isArray(genData.payload.data)) ? (
    [
      [
        "Артикул",
        "Номер заказа",
        "GTIN",
        "ДатаП",
        "КМ По ДатеП",
        "Остаток кодов",
        "КМ маркировано",
        "КМ без агрегации",
        "АК1 кол-во",
        "АК1 кратность",
        "АК1 итого",
        "АК1 без агрегации",
        "АК2 кол-во",
        "АК2 кратность",
        "АК2 итого",
        "КМ проверка"
      ],
      ...genData.payload.data.map(({
        art,
        order_number,
        gtin,
        prod_date,
        value,
        open_codes,
        km_marked_count,
        km_marked_noagg_count,
        agg1_count,
        agg1_size,
        agg1_total,
        agg1_noagg_count,
        agg2_count,
        agg2_size,
        agg2_total,
        km_on_check,
      }) => [
          art,
          order_number,
          gtin,
          prod_date,
          value,
          open_codes,
          km_marked_count,
          km_marked_noagg_count,
          agg1_count,
          agg1_size,
          agg1_total,
          agg1_noagg_count,
          agg2_count,
          agg2_size,
          agg2_total,
          km_on_check,
        ])
    ]
  ) : []
  const userOutArr = (userData?.payload?.data && Array.isArray(userData.payload.data)) ? (
    [
      [
        "Дата",
        "Пользователь",
        "КМ Итого",
        "АК1 Итого",
        "AK2 Итого",
      ],
      ...userData.payload.data.map(({
        repDate,
        userName,
        kmsCount,
        AK1Count,
        AK2COunt,
      }) => [
          repDate,
          userName,
          kmsCount,
          AK1Count,
          AK2COunt,
        ])
    ]
  ) : []
  const tempFindResult = []
  const findResult = []
  return (
    <>
      <div>
        <div style={{ display: "flex", marginTop: "5px" }}>
          <div style={{ margin: "0 10px" }}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Артикул"
              size="small"
              value={barCode}
              onChange={(e) => setBarCode(e?.target?.value !== undefined ? e.target.value : e)}
            // disabled={mainFormState !== 'edit'}
            />
          </div>

          <div style={{ margin: "0 10px" }}>
            <DatePicker
              InputLabelProps={{ shrink: true }}
              label="Дата"
              views={['year', 'month', 'day']}
              slotProps={{
                textField: {
                  size: 'small', // Делает поле компактным, как у обычного TextField
                },
                field: { clearable: true, onClear: () => setDate('') }
              }}
              value={date ? dayjs(date) : null}
              onChange={(newValue) => {
                if (newValue && newValue.isValid()) {
                  setDate(newValue.format('YYYY-MM-DD'));
                } else {
                  setDate(null); // Если поле очистили
                }
              }}
            // disabled={mainFormState !== 'edit'}
            />
          </div>
          <div style={{ margin: "0 10px" }}>
            <Button disabled={!barCode && !date} onClick={handleBuildReport} variant="contained">Запросить</Button>
          </div>
        </div>
      </div>
      {(genOutArr?.length ? (
        <>
          <ArrayExcelSaver data={genOutArr} name={`Основной отчет арт-${barCode} дата:${date}`} />
          <table className="findResult">
            {genOutArr.map((arr, index) => {
              const rezArr = arr.map((item) => (<td>{item}</td>))
              if (index === 0) return (
                <thead>
                  <tr>
                    {rezArr}
                  </tr>
                </thead>
              );
              return (
                <tr>
                  {rezArr}
                </tr>
              )
            })}
          </table>
        </>
      ) : null)}
      {(userOutArr?.length ? (
        <>
          <ArrayExcelSaver data={userOutArr} name={`Отчет по пользователям арт-${barCode} дата:${date}`} />
          <table className="findResult">
            {userOutArr.map((arr, index) => {
              const rezArr = arr.map((item) => (<td>{item}</td>))
              if (index === 0) return (
                <thead>
                  <tr>
                    {rezArr}
                  </tr>
                </thead>
              );
              return (
                <tr>
                  {rezArr}
                </tr>
              )
            })}
          </table>
        </>
      ) : null)}

    </>

  )
}

export default Report;